module.exports = __webpack_public_path__ + "img/round-arrow.59004afd.svg";